
import variable from "../shared/variable"

export default (statusCode: number)=>{
    if (statusCode === 401) {
        return (window.location.href = variable.URL_EDESIGN_PORTAL);
    }
}